import { Component, OnInit } from '@angular/core';
import { ActiveSessions } from 'src/app/model/activeSessions';

import { NzTableModule } from 'ng-zorro-antd/table';

@Component({
  selector: 'app-devicelist',
  templateUrl: './devicelist.component.html',
  styleUrls: ['./devicelist.component.css']
})
export class DevicelistComponent implements OnInit {
  activeProducts: ActiveSessions[];
  listOfDisplayData: ActiveSessions[];
  constructor() { 

// bind data
var activesessionsObject :  ActiveSessions[]= JSON.parse(localStorage.getItem('activesessions'));
this.activeProducts=activesessionsObject;
this.listOfDisplayData =activesessionsObject;

  }

  ngOnInit() {
  }

}
